import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import roleService from "./roleService";
import { flashMessage as flash } from "./../../../utils/flash/index";

const initialState = {
  all_roles: [],
  active_roles: [],
  isLoading: false,
  isSuccess: false,
  createSuccess: false,
  isError: false,
  isActivated: false,
  isUpdated: false,
  searchLoading: false,
  unpaginated_roles: [],
  message: "",
  role_info: {},
};

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    resetRoles: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.createSuccess = false;
      state.isLoading = false;
      state.searchLoading = false;
      state.isUpdated = false;
      state.isActivated = false;
      state.message = "";
    },
    resetRolesStatus: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Fetching Users
      .addCase(fetchAllRoles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        if (action.payload.roles) {
          state.unpaginated_roles = action.payload.non_paginate_roles;
          state.all_roles = action.payload.roles;
        }
      })
      .addCase(fetchAllRoles.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Search Roles
      .addCase(searchRoles.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(searchRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.searchLoading = false;
        if (action.payload.search_all_roles) {
          state.all_roles = action.payload.search_all_roles;
        }
      })
      .addCase(searchRoles.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Fetching single User
      .addCase(fetchSingleRole.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSingleRole.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        if (action.payload.role) {
          state.role_info = action.payload.data;
        }
      })
      .addCase(fetchSingleRole.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Updating role
      .addCase(updateRole.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isUpdated = true;
        if (action.payload.role) {
          state.role_info = action.payload.role;
        }
        // window.location.reload()
        flash("success", action.payload.message);
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Create Role
      .addCase(createRole.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.role) {
          state.isError = false;
          state.createSuccess = true;
          flash("success", "Role created successfully");
          // state.all_users.push(action.payload.user)
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          // let error = action.payload.errors.email;
          state.isLoading = false;
          state.isError = true;
          state.message = "an error occured";
          flash("error", action.payload.errors.staff_id[0]);
        }
      })
      .addCase(createRole.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // deactivate role
      .addCase(deactivateRole.pending, (state) => {
        state.isActivated = false;
      })
      .addCase(deactivateRole.fulfilled, (state, action) => {
        state.isActivated = true;
        flash("success", action.payload.message);
      })
      .addCase(deactivateRole.rejected, (state, action) => {
        state.isActivated = false;
        flash("error", action.payload);
      })
      // activate role
      .addCase(activateRole.pending, (state) => {
        state.isActivated = false;
      })
      .addCase(activateRole.fulfilled, (state, action) => {
        state.isActivated = true;
        flash("success", action.payload.message);
      })
      .addCase(activateRole.rejected, (state, action) => {
        state.isActivated = false;
        flash("error", action.payload);
      })
      // fetching roles
      .addCase(getAllActiveRoles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllActiveRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.active_roles = action.payload;
      })
      .addCase(getAllActiveRoles.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        // flash("error", action.payload);
      });
  },
});

// Create role
export const createRole = createAsyncThunk(
  "/role/create",
  async (roleData, thunkAPI) => {
    try {
      return await roleService.createRole(roleData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Fetch roles
export const fetchAllRoles = createAsyncThunk(
  "/role/getAll",
  async (pageNumber, thunkAPI) => {
    try {
      return await roleService.getAllRoles(pageNumber);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Fetch single role
export const fetchSingleRole = createAsyncThunk(
  "/role/Single",
  async (id, thunkAPI) => {
    try {
      return await roleService.getSingleRole(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Fetch single user
export const updateRole = createAsyncThunk(
  "/role/update",
  async (formData, thunkAPI) => {
    try {
      return await roleService.updateRole(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// deactivate a role
export const deactivateRole = createAsyncThunk(
  "/role/deactivate",
  async (role_id, thunkAPI) => {
    try {
      return await roleService.deactivateRole(role_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// deactivate a role
export const activateRole = createAsyncThunk(
  "/role/activate",
  async (role_id, thunkAPI) => {
    try {
      return await roleService.activateRole(role_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// fetch all active roles
export const getAllActiveRoles = createAsyncThunk(
  "/roles/active",
  async (_, thunkAPI) => {
    try {
      return await roleService.getAllActiveRoles();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// search roles
export const searchRoles = createAsyncThunk(
  "roles/searchRoles",
  async (searchText, thunkAPI) => {
    try {
      return await roleService.searchRoles(searchText);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetRoles, resetRolesStatus } = roleSlice.actions;
export default roleSlice.reducer;
